import { Navigate, useRoutes } from 'react-router-dom';

import DashboardLayout from '../layouts/DashboardLayout';
import Login from "../pages/login/login";
import NotFound from "../pages/notfound/notfound";
import { useAppSelector } from "../redux/store/storehooks";
import LabList from "../pages/lab/LabList";
import TicketList from "../pages/ticket/TicketList";
import MachineList from "../pages/machine/MachineList";
import MachineInstallRequest from "../pages/machineInstalRequest/MachineInstallRequest";
import NewMachineInstallRequest from "../pages/machineInstalRequest/NewMachineInstallRequest";
import FinancialBalance from "../pages/financial/FinancialBalance";
import CableRequest from "../pages/cableRequest/CableRequest";
import SMSRequest from "../pages/sms/smsRequest";
import MachineDefinition from "../pages/machine/MachineDefinition";
import { BankResponse } from "../pages/bankResponse/bankResponse";
import RequestLab from "../pages/request-lab/RequestLab";
import RequestLabUserLab from "../pages/lab/lab-request-lab/labRequestLab";
import RequestPayment from "../pages/lab/requestPyment";
import NewPaymentUpload from "../pages/lab/new-pay-upload";
import RequestPaymentParcik from "../pages/parcik-user/request-pay-pars";
import NewPaymentParcik from "../pages/parcik-user/new-pay-parcik";
import NewPaymentUploadParcik from "../pages/parcik-user/new-pay-upload-parcik";
import UploadFormat from "../pages/lab/upload-formate";
import Proxy from "../pages/remoteControl/proxy";
import LabInfo from "../pages/remoteControl/LabInfo";
import EditFinancialInfo from "../pages/financial/EditFinancialInfo";
import TemperatureInstallRequest from "../pages/temperature/TemperatureInstallRequest";
import NewTemperatureInstallRequest from "../pages/temperature/NewTempratureInstallRequest";
import PadvishRequest from "../pages/padvish/padvishRequest";
import PadvishLicenseRegistration from "../pages/padvish/padvishLicenseRegistration";
import NewPadvishRequest from "../pages/padvish/newPadvishRequest";
import NewPadvishRequestLicense from "../pages/padvish/newPadvishRequestLicense";
import LabLicense from "../pages/padvish/labPadvishLicenses";
import NewPaymentRequest from "../pages/lab/newPaymentRequest";
import NewPaymentRequestFiles from "../pages/lab/newPaymentRequestFiles";
import LabDetails from '../pages/remoteControl/labUser/labDetails';
import VoipManagement from '../pages/remoteControl/VoipManagement';
import TicketManagement from '../pages/TicketManagement/TicketManagement';
import VoipReportManagement from '../pages/remoteControl/voipReport/VoipReportManagement';
import VersionManagement from '../pages/remoteControl/VersionManagement/versionManagement';
import VersionHistory from '../pages/remoteControl/VersionManagement/versionHistory';
import BranchOffice from '../pages/branchOffice/BranchOffice';
import UsersTicket from '../pages/ticket/UsersTicket';
import LabWhiteList from '../pages/LabWhiteList/LabWhiteList';

const Router = () => {

    const auth = useAppSelector((state) => state.auth)

    const myCustomRoute = auth.auth ? AuthenticatedRoutes(auth) : notAuthenticatedRoutes()

    return useRoutes(myCustomRoute);
}


const notAuthenticatedRoutes = () => {
    return (
        [
            { path: '', element: <Login /> },
            { path: '/', element: <Login /> },
            { path: '*', element: <Navigate to="/login" replace />, },
            { path: 'login', element: <Login />, },
            { path: 'response', element: <BankResponse />, },
        ]
    )
}

const AuthenticatedRoutes = (auth: any) => {

    const routes = (auth.auth == true && auth.loginType == "labuser") ? labUsersRoutes() : parsiUsersRoutes()

    return (
        routes
    )

}

const parsiUsersRoutes = () => {
    return (
        [
            {
                path: '/parsicuser',
                element: <DashboardLayout />,
                children: [
                    { path: 'dashboard', element: <LabList /> },
                    { path: 'lab', element: <LabList /> },
                    { path: 'ticket', element: <TicketList /> },
                    { path: 'machine', element: <MachineList /> },
                    {
                        path: 'newMachine',
                        element: <MachineDefinition />,
                        children: [
                            { path: ':machineId', element: <MachineDefinition /> },
                        ]
                    },
                    { path: 'machineInstallRequest', element: <MachineInstallRequest /> },
                    {
                        path: 'NewMachineInstallRequest',
                        element: <NewMachineInstallRequest />,
                        children: [
                            { path: ':requestID', element: <NewMachineInstallRequest /> },
                        ]
                    },
                    { path: 'RequestPayment', element: <RequestPaymentParcik /> },
                    {
                        path: 'PaymentUpload',
                        element: <NewPaymentUploadParcik />
                        , children: [
                            {
                                path: ':id',
                                element: <NewPaymentUploadParcik />,

                            },
                        ]
                    },
                    {
                        path: 'newRequestPayment',
                        element: <NewPaymentParcik />,

                    },
                    { path: 'padvishRequest', element: <PadvishRequest /> },
                    {
                        path: 'PadvishLicenseRegistration',
                        element: <PadvishLicenseRegistration />,
                        children: [
                            { path: ':requestId', element: <PadvishLicenseRegistration /> },
                        ]
                    },
                    {
                        path: 'newPadvishRequestLicense',
                        element: <NewPadvishRequestLicense />,
                        children: [
                            { path: ':requestId', element: <NewPadvishRequestLicense /> },
                        ]
                    },
                    {
                        path: 'newPadvishRequest',
                        element: <NewPadvishRequest />,
                        children: [
                            { path: ':requestID', element: <NewPadvishRequest /> },
                        ]
                    },
                    { path: 'temperatureInstallRequest', element: <TemperatureInstallRequest /> },
                    {
                        path: 'NewTemperatureInstallRequest',
                        element: <NewTemperatureInstallRequest />,
                        children: [
                            { path: ':requestID', element: <NewTemperatureInstallRequest /> },
                        ]
                    },
                    { path: 'cableRequest', element: <CableRequest /> },
                    { path: 'ticketManagement', element: <TicketManagement fromDate={''} toDate={''} tableShow={true} /> },
                    { path: 'UsersTicket', element: <UsersTicket /> },
                    { path: 'financialBalance', element: <FinancialBalance /> },
                    { path: 'SMSRequest', element: <SMSRequest /> },
                    { path: 'RequestLab', element: <RequestLab /> },
                    { path: 'notfound', element: <NotFound /> },
                    { path: '/parsicuser/proxy', element: <Proxy /> },
                    { path: 'voipManagement', element: <VoipManagement /> },
                    { path: 'voipReportManagement', element: <VoipReportManagement /> },
                    { path: 'versionManagement', element: <VersionManagement /> },
                    { path: 'versionHistory', element: <VersionHistory /> },
                    { path: 'branchOffice', element: <BranchOffice /> },
                    { path: 'LabWhiteList', element: <LabWhiteList /> },


                    // { 
                    //     path: 'proxy', 
                    //     element: <Proxy />,
                    //     children: [
                    //       { path: ':labInfo', element: <LabInfo /> },
                    //     ]
                    // },
                ]
            },
            { path: '/parsicuser/labInfo', element: <LabInfo /> },
            { path: '*', element: <Navigate to="/parsicuser/dashboard" replace /> },
            { path: '/', element: <Navigate to="/parsicuser/dashboard" replace /> },
            { path: '', element: <Navigate to="/parsicuser/dashboard" replace /> }
        ]

    )
}

const labUsersRoutes = () => {
    return (
        [
            {
                path: '/labuser',
                element: <DashboardLayout />,
                children: [
                    { path: 'dashboard', element: <FinancialBalance /> },
                    { path: 'editfinancialInfo', element: <EditFinancialInfo /> },
                    { path: 'labInfo', element: <LabDetails /> },
                    { path: 'machineInstallRequest', element: <MachineInstallRequest /> },
                    {
                        path: 'NewMachineInstallRequest',
                        element: <NewMachineInstallRequest />,
                        children: [
                            { path: ':requestID', element: <NewMachineInstallRequest /> },
                        ]
                    },
                    { path: 'temperatureInstallRequest', element: <TemperatureInstallRequest /> },
                    {
                        path: 'NewTemperatureInstallRequest',
                        element: <NewTemperatureInstallRequest />,
                        children: [
                            { path: ':requestID', element: <NewTemperatureInstallRequest /> },
                        ]
                    },
                    { path: 'padvishRequest', element: <PadvishRequest /> },
                    {
                        path: 'labLicense',
                        element: <LabLicense />,
                        children: [
                            { path: ':requestId', element: <LabLicense /> },
                        ]
                    },
                    {
                        path: 'newPadvishRequest',
                        element: <NewPadvishRequest />,
                        children: [
                            { path: ':requestID', element: <NewPadvishRequest /> },
                        ]
                    },
                    { path: 'RequestLab', element: <RequestLabUserLab /> },
                    { path: 'RequestPayment', element: <RequestPayment /> },
                    { path: 'NewPaymentRequestFiles', element: <NewPaymentRequestFiles /> },

                    {
                        path: 'UploadFormat',
                        element: <UploadFormat />
                        , children: [
                            {
                                path: ':id',
                                element: <UploadFormat />,

                            },
                        ]
                    },
                    {
                        path: 'PaymentUpload',
                        element: <NewPaymentUpload />
                        , children: [
                            {
                                path: ':id',
                                element: <NewPaymentUpload />,

                            },
                        ]
                    },
                    {
                        path: 'newRequestPayment',
                        element: <NewPaymentRequest />,

                    },

                    { path: 'financialBalance', element: <FinancialBalance /> },
                    { path: 'SMSRequest', element: <SMSRequest /> },
                    { path: 'notfound', element: <NotFound /> },

                ]
            },
            { path: '*', element: <Navigate to="/labuser/dashboard" replace /> },
            { path: '/', element: <Navigate to="/labuser/dashboard" replace /> },
            { path: '', element: <Navigate to="/labuser/dashboard" replace /> },

        ]
    )
}

export default Router;